import {
  Storage,
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
  CLEAR,
} from 'app/models/localStorage/constants';
import { storageReducers } from 'app/models/storage/reducers';

export const localStorageReducers = storageReducers(
  Storage,
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
  CLEAR,
);
